import { ProductPageQuery } from '../../generated/graphql'

type ContentItem = NonNullable<
  Required<ProductPageQuery['product']>
>['content'][0]

export const productContent = (
  product: { content: ContentItem[] },
  indexedKeys: { [key: string]: string[] },
): { [key: string]: ContentItem[] } => {
  if (!product) {
    return {}
  }

  const keys = Object.keys(indexedKeys)

  return product.content.reduce((accumulator, item) => {
    const key =
      keys.find(
        (key) => indexedKeys[key] && indexedKeys[key].indexOf(item.key) > -1,
      ) || 'content'

    if (!accumulator[key]) {
      accumulator[key] = []
    }

    accumulator[key].push(item)
    return accumulator
  }, {})
}
